import { MutateOptions } from '@tanstack/react-query';
import { FormikHelpers } from 'formik';
import toast from 'react-hot-toast';
import { handleErrorsResponse } from 'utils/service/errorHandler';

interface IForm {}
interface IMutation {}
interface IResponse {}
type IContext = unknown;

type useMutateOptionsType<
  Form = {},
  Mutation = {},
  Response = {},
  Context = {}
> = (
  formikHelpers: FormikHelpers<Form>
) => MutateOptions<Response, Error, Mutation, Context>;

export const useMutateOptions = <
  Form extends IForm,
  Mutation extends IMutation = {},
  Response extends IResponse = {},
  Context = IContext
>(): useMutateOptionsType<Form, Mutation, Response, Context> => {
  const handleErrors = (
    error: Error,
    variables: Mutation,
    formikHelpers: FormikHelpers<Form>,
    context?: Context
  ) => {
    const { formik, toasts } = handleErrorsResponse<Form>(error.message);

    if (Object.keys(formik).length) {
      console.log('formik', formik);
      formikHelpers.setErrors(formik);
    }

    if (toasts.length) {
      console.log('toasts', toasts);
      toasts.map(error => toast.error(error));
    }
  };

  const mutateOptions = (
    formikHelpers: FormikHelpers<Form>
  ): MutateOptions<Response, Error, Mutation, Context> => ({
    onError: (error: Error, variables: Mutation, context?: Context) =>
      handleErrors(error, variables, formikHelpers, context),
  });

  return mutateOptions;
};
